module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modules/page-header/page-header.component.scss
// module id = ./src/app/shared/modules/page-header/page-header.component.scss
// module chunks = main